import type { simulation } from '@/features/dashboard/types.api';
import { baseScalesOptions, commonLegendOptions, commonTooltipOptions } from '@/utils/chartConfig';
import { useMemo } from 'react';

const getDefaultHistoricalChartOptions = () => ({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            ...baseScalesOptions.x,
            grid: { color: 'rgba(255, 255, 255, 0.05)' },
            ticks: { color: '#94A3B8', font: { size: 12 } },
        },
        y: {
            ...baseScalesOptions.y,
            beginAtZero: false,
            grid: { color: 'rgba(255, 255, 255, 0.05)' },
            ticks: { color: '#94A3B8', font: { size: 11 } },
        },
    },
    plugins: {
        legend: {
            display: true,
            position: 'top' as const,
            ...commonLegendOptions,
        },
        tooltip: {
            ...commonTooltipOptions,
        },
    },
});

export const useHistoricalChart = (simulations: simulation[] | undefined) => {
    const lineChartData = useMemo(() => {
        if (!simulations || simulations.length === 0) {
            return { labels: [], datasets: [] };
        }

        const sortedSimulations = [...simulations].sort(
            (a, b) => new Date(a.created_at || '').getTime() - new Date(b.created_at || '').getTime()
        );

        return {
            labels: sortedSimulations.map(sim => sim.name),
            datasets: [
                {
                    label: 'Puntaje Promedio',
                    data: sortedSimulations.map(sim => sim.summary?.globalScore || null),
                    borderColor: 'rgba(59, 130, 246, 1)',
                    backgroundColor: 'rgba(59, 130, 246, 0.15)',
                    borderWidth: 2.5,
                    tension: 0.4,
                    fill: true,
                    pointBackgroundColor: 'rgba(59, 130, 246, 1)',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgba(59, 130, 246, 1)',
                    pointRadius: 4,
                    pointHoverRadius: 6,
                },
            ],
        };
    }, [simulations]);

    const lineChartOptions = useMemo(() => getDefaultHistoricalChartOptions(), []);

    return { lineChartData, lineChartOptions };
};
